import React, {PureComponent} from 'react'
import ReactTable from 'react-table'
import {Link} from 'react-router-dom'
import {Button, Collapse} from 'reactstrap'
import moment from 'moment'

import GoKids from '../../services/GoKids'
import PageTitle from '../../components/PageTitle'
import DataFetchPage from '../../components/DataFetchPage'
import {readMoney} from '../../helpers/format'
import DriverPaymentForm from '../../components/DriverPaymentForm'

class DriverPaymentList extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {showForm: false};
  }

  componentDidMount() {
    const driverId = this.props.match.params.id;
    GoKids.getDriver(driverId).then(driver => this.setState({driver}));
  }

  loadFromApi = () => GoKids.getDriverPayments(this.props.match.params.id);

  refresh =  () => this._fetch.refresh();

  toggleShowForm = () => this.setState({showForm: !this.state.showForm});

  removePayment = async paymentId => {
    const driverId = this.props.match.params.id;
    await GoKids.deletePayment(driverId, paymentId);
    await this.refresh();
  };

  render() {
    const {driver} = this.state;

    return (
      <React.Fragment>
        <PageTitle
          title={driver ? driver.fullName : 'Carregando...'}/>
        <div className="card card-table">
          <DataFetchPage
            ref={fetch => this._fetch = fetch}
            fetch={this.loadFromApi}
            extraData={this.state.showForm}
            renderToolbar={this.renderTopActions}
            renderContent={this.renderContent}/>
        </div>
      </React.Fragment>
    );
  }

  renderTopActions = ({data, isLoading}) => (
    <React.Fragment>
      <div className="card-top-actions">
        <h4>Lista de pagamentos</h4>
        <Button tag={Link} to="/maetoristas" color="link">Ver mãetoristas</Button>
        <Button color="primary" onClick={this.toggleShowForm}>Novo pagamento</Button>
      </div>
      <Collapse isOpen={this.state.showForm}>
        <DriverPaymentForm
          driverId={this.props.match.params.id}
          onCreate={this.refresh} />
      </Collapse>
    </React.Fragment>
  );

  renderContent = ({isLoading, data}) => (
    <ReactTable
      loading={isLoading}
      data={data || []}
      columns={[{
        Header: 'Data do pagamento',
        accessor: 'date',
        Cell: ({value}) => moment(value, 'YYYYMMDD').format('L'),
      }, {
        Header: 'Valor',
        accessor: 'value',
        Cell: ({value}) => value ? readMoney(value) : '',
      }, {
        width: 110,
        className: 'cell-actions',
        accessor: '_id',
        Cell: ({value}) => (
          <Button size="sm" color="link" onClick={() => this.removePayment(value)}>remover</Button>
        ),
      }]}
    />
  );
}

export default DriverPaymentList;



// WEBPACK FOOTER //
// ./src/screens/driver/DriverPaymentList.js